@if (isCustom()) {
	<div #custom></div>
} @else if (isSlider() && sliderData()) {
	<div #slider class="filter-slider">
		@let data = sliderData();

		<mat-slider
			[disabled]="locked()"
			[min]="data.min"
			[max]="data.max"
			[step]="data.interval"
			[showTickMarks]="true"
			[discrete]="true"
			class="nha-filter-slider"
		>
			@if (filter().multiple) {
				<input matSliderStartThumb [value]="selected()" (valueChange)="selectSliderLowValue($event)" />
				<input matSliderEndThumb [value]="highSelected()" (valueChange)="selectSliderHighValue($event)" />
			} @else {
				<input matSliderThumb [value]="selected()" (valueChange)="selectSliderValue($event)" />
			}
		</mat-slider>
		<div class="slider-label">
			<div>{{ filter().items[0].label }}</div>
			<div>{{ filter().items.last().label }}</div>
		</div>
	</div>
} @else {
	<div class="chip-content">
		@if (showSearch()) {
			<mat-form-field appearance="outline">
				<mat-label>Search</mat-label>
				<input matInput nhaTest="filter-search" [value]="searchTerm()" (input)="searchTerm.set($event.target.value)" />
			</mat-form-field>
		}

		<div class="filter-chip-list">
			@for (item of filterItems(); track item.id) {
				@let itemCount = countFor(item);
				@let itemDisabled = disabledFor(item);
				<nha-chip
					[icon]="item.selected ? 'check' : ''"
					iconSize="18px"
					[color]="item.selected ? 'blue' : itemDisabled || locked() ? 'gray' : 'clear'"
					[ngClass]="{ locked: locked(), disabled: itemDisabled, selected: item.selected }"
					[attr.aria-disabled]="itemDisabled ? 'true' : null"
					[attr.aria-label]="counts() ? itemAriaLabel(item, itemCount) : null"
					(clicked)="select(filterKey(), filter(), item.id); $event.stopPropagation()"
				>
					<span chip-content>
						{{ item.label }}
						@if (counts() && itemCount !== null) {
							<span class="chip-item-count">{{ itemCount }}</span>
						}
					</span>
				</nha-chip>
			}
		</div>
	</div>
}
